var Module = {
    name: 'parseQuery',
    data: {},
    /* get data from url string  */
    parseQuery: function ( string ) {
        if( string ) {
            var pairs = (string[0] === '?' ? string.substr(1) : string).split('&')
            for ( var i = 0; i < pairs.length; i++ ) {
                var pair = pairs[i].split('=')
                Module.data[decodeURIComponent(pair[0])] = decodeURIComponent(pair[1] || '')
            }
            return Module.data
        }
        return false
    }
}

module.exports = Module
